import { withRouter } from 'react-router-dom';
import WithSystem from './../service/WithSystem';
const certificateFilter = JSON.parse(window.certificaterelease);
class ProgressCompleteDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.box   = React.createRef();
    this.state = { dropdownToggle: false }
  }
  SetDropdownToggleVall = () => {
    this.setState({ dropdownToggle: !this.state.dropdownToggle }, () => {
      document.addEventListener('click', this.handleOutsideClick);
    });
  }
  handleOutsideClick = (event) => {
    if (this.box && !this.box.current.contains(event.target)) {
      this.setState({ dropdownToggle: !this.state.dropdownToggle }, () => {
        if (this.state.dropdownToggle == true) {
          this.setState({ dropdownToggle: false });
        }
        document.removeEventListener('click', this.handleOutsideClick);
      });
    }
  }
  setProgressComplete = (param) => {    
    this.props.setGlobalState({ maxProgressRange: false, minProgressRange: false, progressstatus:param });
  }
  render() {
    const ProgressCompleteItems = this.props.queryFilter['progressstatus'] ? this.props.queryFilter['progressstatus'] : 'Course Status';
    return (
      <div ref={this.box} onClick={() => this.SetDropdownToggleVall()} className={this.state.dropdownToggle == true ? 'branch-list course_status_dropdown active' : 'branch-list course_status_dropdown'}>
        <span className="filter-subtxt">Course Status</span>
          <div className="dropdown bc-column-selector">
              <div className="branch-list-sec" data-toggle="dropdown" aria-expanded="false">{ProgressCompleteItems}</div>
              <ul className="dropdown-menu">
            <li onClick={(e) => this.setProgressComplete('Completed')}> <span className="checkedmark"></span> Completed</li>
            <li onClick={(e) => this.setProgressComplete('Not Started')}> <span className="checkedmark"></span>Not Started</li>
            <p><svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px"><path d="M 24 4 C 12.972066 4 4 12.972074 4 24 C 4 35.027926 12.972066 44 24 44 C 35.027934 44 44 35.027926 44 24 C 44 12.972074 35.027934 4 24 4 z M 24 7 C 33.406615 7 41 14.593391 41 24 C 41 33.406609 33.406615 41 24 41 C 14.593385 41 7 33.406609 7 24 C 7 14.593391 14.593385 7 24 7 z M 24 14 A 2 2 0 0 0 24 18 A 2 2 0 0 0 24 14 z M 23.976562 20.978516 A 1.50015 1.50015 0 0 0 22.5 22.5 L 22.5 33.5 A 1.50015 1.50015 0 1 0 25.5 33.5 L 25.5 22.5 A 1.50015 1.50015 0 0 0 23.976562 20.978516 z"></path></svg> <span>Notes:Selecting and altering the course status filter will automatically reset the course progress filter.</span></p>
            </ul>
          </div>
      </div>
    );
  }
}
export default withRouter(WithSystem(ProgressCompleteDropDown));
